__turbopack_context__.v({
  "buttonWrapper": "F9ncMq_buttonWrapper",
  "controls": "F9ncMq_controls",
  "productWrapper": "F9ncMq_productWrapper",
  "replacementsAbsolute": "F9ncMq_replacementsAbsolute",
  "replacementsSliderWrapper": "F9ncMq_replacementsSliderWrapper",
  "slider": "F9ncMq_slider",
  "sliderAbsolute": "F9ncMq_sliderAbsolute",
  "sliderContainer": "F9ncMq_sliderContainer",
  "sliderWrapper": "F9ncMq_sliderWrapper",
  "wrapper": "F9ncMq_wrapper",
});
